export const printConstants = {
  GETPRINT_REQUEST: "GETPRINT_REQUEST",
  GETPRINT_SUCCESS: "GETPRINT_SUCCESS",
  GETPRINT_FAILURE: "GETPRINT_FAILURE",

  GETPRINT_PRODUCT_REQUEST: "GETPRINT_PRODUCT_REQUEST",
  GETPRINT_PRODUCT_SUCCESS: "GETPRINT_PRODUCT_SUCCESS",
  GETPRINT_PRODUCT_FAILURE: "GETPRINT_PRODUCT_FAILURE"
};
